import React from 'react';

interface TabProps<T> {
  tabs: T[];
  activeTab: T;
  setActiveTab: (tab: T) => void;
  renderTabContent: (tab: T) => JSX.Element;
}

export default function PageWithTabsLayout<T extends string>({
  tabs,
  activeTab,
  setActiveTab,
  renderTabContent,
}: TabProps<T>): JSX.Element {
  return (
    <>
      <div className="mb-6 flex gap-4 border-b border-primary-300">
        {tabs.map((tabKey) => (
          <button
            key={tabKey}
            type="button"
            onClick={() => setActiveTab(tabKey)}
            className={`relative px-4 pb-1 pt-2 font-medium transition-all duration-150 ${
              activeTab === tabKey
                ? 'text-primary-700 -mb-[1px] rounded-t-md border border-primary-300 border-b-secondary-50'
                : 'text-primary-600 hover:text-primary-800'
            }`}>
            {tabKey.charAt(0).toUpperCase() + tabKey.slice(1)}
          </button>
        ))}
      </div>

      <div className="mb-8 flex flex-col gap-6 lg:flex-row">
        {renderTabContent(activeTab)}
      </div>
    </>
  );
}